"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[946],{

/***/ 4984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useSortWorkingHours__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6349);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8757);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8728);






function WorkingHours(param) {
    let { workingHours  } = param;
    const today = (0,utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .getNameOfDay */ .Hl)().toLowerCase();
    const sorting = (0,hooks_useSortWorkingHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(workingHours);
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "space-y-2",
        children: sorting.map((param)=>{
            let { d , time  } = param;
            var _time_, _time_1;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex align-center flex-wrap space-x-4", {
                    "text-primary-500": today == d
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "flex-1 capitalize",
                        children: [
                            t("workingHours.weekdays.".concat(d)),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "flex-none text-sm leading-6",
                        children: time.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                (0,utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatTime24 */ .V5)((_time_ = time[0]) === null || _time_ === void 0 ? void 0 : _time_.start),
                                " – ",
                                (0,utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatTime24 */ .V5)((_time_1 = time[0]) === null || _time_1 === void 0 ? void 0 : _time_1.end)
                            ]
                        }) || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: t("workingHours.closed")
                        })
                    })
                ]
            }, d);
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(WorkingHours));


/***/ }),

/***/ 6349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);

const useSortWorkingHours = (workingHours)=>{
    const sorting = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (!workingHours) return [];
        const times = [];
        Object.entries(workingHours).forEach(function(param) {
            let [day, time] = param;
            times.push({
                d: day,
                time
            });
        });
        const sorter = {
            // "sunday": 0, // << if sunday is first day of week
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
            sunday: 7
        };
        times.sort((a, b)=>{
            let day1 = a.d.toLowerCase();
            let day2 = b.d.toLowerCase();
            return sorter[day1] - sorter[day2];
        });
        return times;
    }, [
        workingHours
    ]);
    return sorting;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSortWorkingHours);


/***/ })

}]);